import { IntegrationsMarketplaceAppContainerView } from '../view/IntegrationsMarketplaceAppContainerView';
import { templateIntegrationsMarketplaceAppContainer } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
} from '../../../framework/BaseWebComponentController';
import { IntegrationsMarketplaceAppContainerWebComponent } from '..';
import { IntegrationsMarketplaceAppContainerWebComponentSchema } from '../types';
import {FilterEvents, GridEvents} from "../../../grid/types/common";
import {GzButtonWebComponent} from "../../../ui/gzButton";
import {ColumnKeys, STATUS_FILTER} from "../types/filter-data";
import {convertGridFiltersToExtJsFilters} from "../../../grid/utils/filters";
import {ElementClass} from "../../../utils/htmlElement.utils";
import {SaveIntegrationEvents} from "../../saveIntegration/types";
import {TemplateState} from "../../../types/common/types";
import {ButtonEvents} from "../../../ui/gzButton/types";
import {INTEGRATIONS_DOCUMENTATION_LINK} from "../../common/constants";
import {IntegrationsMarketplaceHistoryLogsWebComponent} from "../../integrationsMarketplaceHistoryLogs";
import {HistoryLogEvents} from "../../integrationsMarketplaceHistoryLogs/types";

export class IntegrationsMarketplaceAppContainerController extends BaseWebComponentController {
  public component: IntegrationsMarketplaceAppContainerWebComponent;
  public view: IntegrationsMarketplaceAppContainerView;
  public viewConstructor: typeof IntegrationsMarketplaceAppContainerView;
  public historyLogsPanel: IntegrationsMarketplaceHistoryLogsWebComponent;

  public dom: {
    $saveIntegrationButton: GzButtonWebComponent;
  };
  constructor(component: IntegrationsMarketplaceAppContainerWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrationsMarketplaceAppContainerView,
      viewTemplate: templateIntegrationsMarketplaceAppContainer,
    });
  }

  async getDataForView(): Promise<IntegrationsMarketplaceAppContainerWebComponentSchema> {
    return {};
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$gridFilters,
        event: FilterEvents.FILTERS_UPDATED,
        callback: this.handleReloadGrid,
      },
      {
        element: this.view.dom.$availableGrid,
        event: SaveIntegrationEvents.ReloadGrid,
        callback: this.handleReloadGrid,
      },
      {
        element: this.view.dom.$installedGrid,
        event: SaveIntegrationEvents.ReloadGrid,
        callback: this.handleReloadGrid,
      },
      {
        element: this.view.dom.$headerBannerButton,
        event: ButtonEvents.CLICK,
        callback: this.redirectToDocumentation,
      },
      {
        element: this.view.dom.$installedGrid,
        event: SaveIntegrationEvents.ViewLogs,
        callback: this.showHistoryLogs
      },
      {
        element: this.view.dom.$gridDataRefresh,
        event: "click",
        callback: this.handleReloadGrid
      },
    ];
  }

  private handleReloadGrid = (event) => {

    const filters = this.view.dom.$gridFilters.filters;

    const promises = [
      this.view.dom.$installedGrid.controller.reloadGrid(filters)
    ];

    // if this is triggered from somewhere else than the refresh button, we need to reload the available grid as well
    if(event.target.id !== 'gridDataRefresh') {
      promises.push(this.view.dom.$availableGrid.controller.reloadGrid(filters));
    }

    this.handleEnabledGridFilter(false);
    // handle grid filtering enable disabled
    Promise.all(promises).then(() => {
      this.handleEnabledGridFilter(true);
    });

  }

  private handleEnabledGridFilter(enabled: boolean) {
    if (enabled) {
      this.view.removeElementClass(this.view.dom.$gridFilters, TemplateState.DISABLED);
    } else {
      this.view.setElementClass(this.view.dom.$gridFilters, TemplateState.DISABLED);
    }

  }

  private redirectToDocumentation = () => {
    window.open(INTEGRATIONS_DOCUMENTATION_LINK, '_blank');
  }

  private async showHistoryLogs(data): Promise<void> {
    if (!this.historyLogsPanel) {
      this.historyLogsPanel = new IntegrationsMarketplaceHistoryLogsWebComponent(this.dependencies);
      this.historyLogsPanel.addEventListener(HistoryLogEvents.CLOSE, () => {
        this.view.dom.$sideMenu.closeSideMenu();
      });
    }

    this.historyLogsPanel.integrationId = data.detail.integrationId;

    this.view.dom.$sideMenu.setMenuContent(this.historyLogsPanel);
    this.view.dom.$sideMenu.openSideMenu();
  }
}
